<template>
    <div>
        <div class="row">
            <div class="col-md-12">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item">
                            <router-link :to="{name:'home'}">{{$t("inicio")}}</router-link>
                        </li>
                        <li class="breadcrumb-item">
                            <router-link :to="{name:'informes'}">{{$t("informes")}}</router-link>
                        </li>
                        <li class="breadcrumb-item active" aria-current="page">{{$t('ventasDeMateriasPrimas')}}</li>
                    </ol>
                </nav>
            </div>
            <CabeceraInformes
                :idBusiness="idBusiness"
                :listBusinesses="listBusinesses"
                :idTpv="idTpv"
                :listTpv="listTpv"
                :dateto="dateto"
                :datefrom="datefrom"
                id="cabecera"
                :conTodos="true"
            />
            <template v-if="!permiso">
                <div class="alert alert-danger m-3" style="width: 100%" role="alert">
                    Lo sentimos. Este negocio no cuenta con este módulo activado.
                </div>
            </template>
            <!--<div class="col-md-12">
                <div class="card">
                    <div class="row">
                        <div class="col-md-3">
                            <div class="form-group">
                                <label for="listBusiness">{{$t("negocio")}}</label>

                                <el-select class="select-default"
                                           size="large"
                                           v-model="idBusiness"
                                           filterable
                                           :placeholder="$t('seleccionaNegocio')"
                                           @change="getTpv(),idsTPV=[], idFiltro=0">
                                    <el-option v-for="business in listBusinesses"
                                               class="select-primary"
                                               :value="business.id"
                                               :label="business.establishmentName"
                                               :key="business.id">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>

                        <div class="col-md-3">
                            <div class="form-group">

                                <label for="listTPV">{{$t("TPV")}}</label>

                                <div class="row">
                                    <div class="col-8">
                                        <el-select class="select-default"
                                                   size="large"
                                                   v-model="idTpv"
                                                   filterable
                                                   @change="changeTPV()"
                                                   :placeholder="$t('seleccionaTpv')">
                                            <el-option v-for="tpv in listTpv"
                                                       class="select-primary"
                                                       :value="tpv.id"
                                                       :label="tpv.nameShow"
                                                       :key="tpv.id">
                                            </el-option>

                                        </el-select>

                                    </div>

                                    <div class="col-4">
                                        <button class="btn btn-primary"
                                                @click="openModal()"><i
                                                class="fa fa-filter"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>

                        </div>

                        <div class="col-md-2">
                            <div class="form-group">
                                <label>{{$t("fechaInicio")}}</label>
                                <datetime
                                        value-zone="Europe/Madrid"
                                        :auto="true"
                                        class="theme-numier"
                                        format="dd-MM-yyyy"
                                        :title="$t('fechaInicio')"
                                        :phrases="{ok: $t('aceptar'), cancel: $t('salir')}"
                                        input-class="form-control"
                                        v-model="datefrom"></datetime>
                            </div>
                        </div>

                        <div class="col-md-2">
                            <div class="form-group">
                                <label>{{$t("fechaFin")}}</label>
                                <datetime
                                        value-zone="Europe/Madrid"
                                        :auto="true"
                                        class="theme-numier"
                                        :title="$t('fechaFin')"
                                        format="dd-MM-yyyy"
                                        :phrases="{ok: $t('aceptar'), cancel: $t('salir')}"
                                        input-class="form-control"
                                        v-model="dateto"></datetime>
                            </div>
                        </div>


                        <div class="col-md-2">
                            <label>&nbsp;</label>
                            <div class="form-group">
                                <button class="btn btn-primary" @click="getSalesProducts()">
                                    <img src="static/img/sync.gif" alt="" v-if="loading" width="15">
                                    {{$t("consultar")}}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>-->


            <div class="col-md-9" v-else-if="respuesta">
                <template>
                    <div class="row justify-content-between div-export">
                        <div class="col-md-4 text-left" style="margin-bottom: 4px">
                            <el-select class="select-default filterTag"
                                    size="large"
                                    filterable
                                    v-model="idFiltro"
                                    @change="getSalesProducts()"
                                    placeholder="Filtrar por etiqueta">
                                <el-option v-for="tag in filterTag "
                                        class="select-primary"
                                        :value="tag.id"
                                        :label="tag.name"
                                        :key="tag.id">
                                </el-option>
                            </el-select>
                        </div>
                        <div class="col-md-8 col-xs-12 text-right" v-if="list.length>0"> 
                            <el-dropdown>
                                <el-button type="primary" size="small">
                                    <i class="fa fa-file"></i>
                                    {{$t("exportarInforme")}} <i class="el-icon-arrow-down el-icon--right"></i>
                                </el-button>
                                <el-dropdown-menu slot="dropdown">
                                    <a :href="urlExportPDF">
                                        <el-dropdown-item class="text-danger">
                                            <strong><i class="fa fa-file-pdf"></i> {{$t("exportarPdf")}}</strong>
                                        </el-dropdown-item>
                                    </a>
                                    <a :href="urlExportExcel">
                                        <el-dropdown-item class="text-success">
                                            <strong><i class="fa fa-file-excel"></i> {{$t("exportarExcel")}}</strong>
                                        </el-dropdown-item>
                                    </a>
                                </el-dropdown-menu>
                            </el-dropdown>

                        </div>
                    </div>
                </template>
                <template v-if="list.length > 0">
                    <div class="table-responsive">
                        <table class="table table-bordered table-striped text-nowrap">
                            <thead class="thead-dark">
                            <tr style="cursor: pointer;">
                                <th v-if="ordenacionProductos===0" @click="sortedArrayNameASC('name')">
                                    <i style="color: white" class="fa fa-angle-up"></i> {{$t("producto")}}
                                </th>
                                <th v-else @click="sortedArrayNameDESC('nameTag')"><i
                                        style="color: white" class="fa fa-angle-down"></i> {{$t("producto")}}
                                </th>
                                <th v-if="ordenacionBarcode === 0" @click="sortedArrayBarcodeASC('cod_ean')">
                                    <i style="color: white" class="fa fa-angle-up"></i> {{$t("codigoBarras")}}
                                </th>
                                <th v-else @click="sortedArrayBarcodeDESC('cod_ean')">
                                    <i style="color: white" class="fa fa-angle-down"></i> {{$t("codigoBarras")}}
                                </th>
                                <th v-if="ordenacionProveedor===0" @click="sortedArrayNameProveedorASC('nameProveedor')">
                                    <i style="color: white" class="fa fa-angle-up"></i> {{$t("proveedor")}}
                                </th>
                                <th v-else @click="sortedArrayNameProveedorDESC('nameProveedor')">
                                    <i style="color: white" class="fa fa-angle-down"></i> {{$t("proveedor")}}
                                </th>
                                <th v-if="ordenacionTag===0" @click="sortedArrayNameTagASC('nameTag')">
                                    <i style="color: white" class="fa fa-angle-up"></i> {{$t("etiqueta")}}
                                </th>
                                <th v-else @click="sortedArrayNameTagDESC('nameTag')">
                                    <i style="color: white" class="fa fa-angle-down"></i> {{$t("etiqueta")}}
                                </th>
                                <th v-if="ordenarCantidad===0" @click="sortedArrayCantidadASC('cantidad')">
                                    <i style="color: white" class="fa fa-angle-up"></i> {{$t("unidades")}}
                                </th>
                                <th v-else @click="sortedArrayCantidadDESC('cantidad')">
                                    <i style="color: white" class="fa fa-angle-down"></i> {{$t("unidades")}}
                                </th>
                                <th v-if="ordenarCantidad===0" @click="sortedArrayCantidadASC('cantidad')">
                                    <i style="color: white" class="fa fa-angle-up"></i> {{$t("partes")}}
                                </th>
                                <th v-else @click="sortedArrayCantidadDESC('cantidad')">
                                    <i style="color: white" class="fa fa-angle-down"></i> {{$t("partes")}}
                                </th>
                                <th v-if="ordenarTipo===0" @click="sortedArrayTipoASC('tipo')">
                                    <i style="color: white" class="fa fa-angle-up"></i> {{$t('tipo')}}
                                </th>
                                <th v-else @click="sortedArrayTipoDESC('tipo')">
                                    <i style="color: white" class="fa fa-angle-down"></i> {{$t('tipo')}}
                                </th>
                                <th v-if="ordenarCosto===0" @click="sortedArrayCostoASC('cantidad')">
                                    <i style="color: white" class="fa fa-angle-up"></i> {{$t('coste')}}
                                </th>
                                <th v-else @click="sortedArrayCostoDESC('cantidad')">
                                    <i style="color: white" class="fa fa-angle-down"></i> {{$t('coste')}}
                                </th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="obj in list">
                                <td>{{obj.name}}</td>
                                <td>{{obj.cod_ean}}</td>
                                <td>{{obj.nameProveedor}}</td>
                                <td>{{obj.nameTag}}</td>
                                <td>{{calcularUnidades(obj.units, obj.escandallo)}}</td>
                                <td>{{calcularPartes(obj.units,obj.escandallo)}}</td>
                                <!-- <td>
                                {{calcularUnidades(obj.units,obj.escandallo)}}
                                <template v-if="obj.escandallo>1">
                                        / {{calcularPartes(obj.units,obj.escandallo)}}
                                    </template>
                                </td> -->
                                <td>{{obj.type}}</td>
                                <td>
                                <template v-if="obj.escandallo>1">
                                    {{(obj.precioCompra / obj.escandallo) * obj.units
                                        | currency}}
                                </template>
                                <template v-else>
                                    {{obj.precioCompra * obj.units
                                        | currency}}
                                </template>
                                </td>
                            </tr>
                            </tbody>
                            <tfoot>
                            <tr class="table-success">
                                <td><strong>{{$t("total")}}</strong></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td><strong>{{ getTotalPrecio | currency}}</strong></td>
                            </tr>
                            </tfoot>
                        </table>
                    </div>
                </template>
                <template v-else>
                    <div class="alert alert-danger" role="alert">
                        {{$t("noHayVentasDeProductosEnEsteRangoDeFechas")}}
                    </div>
                </template>
            </div>

            <div class="col-md-3 " v-show="this.list.length > 0 && respuesta && permiso">

                <div class="card">

                    <div class="chart-container col-md-12" style="height:300px; width: 100%">
                        <canvas id="chart"></canvas>
                    </div>

                </div>
            </div>

            <modal name="filtradoTPV" :adaptive=true :scrollable=true height="auto" :clickToClose=true>
                <div>
                    <div class="modal-header">
                        <h4 style="margin: 0px">{{$t("filtrarPorTPV")}}</h4>
                    </div>
                    <div class="modal-body">

                        <el-checkbox-group :min="1" v-model="idsTPV" size="medium">
                            <el-checkbox v-for="tpv in listCheckBoxTpv" :label=tpv.id :key="tpv.id" border>
                                {{tpv.nameShow}}
                            </el-checkbox>
                        </el-checkbox-group>


                    </div>
                    <div class="modal-footer">
                        <div align="right" class="col-12">
                            <button class="btn btn-primary" @click="getSalesProducts()"><i class="fa fa-search"></i>
                                {{$t("filtrarTPV")}}
                            </button>
                        </div>
                    </div>
                </div>
            </modal>

        </div>
    </div>

</template>

<script>

    import Datepicker from 'vuejs-datepicker';
    import Chart from 'chart.js';
    import {
        DatePicker, Select, Option, Dropdown, DropdownItem, DropdownMenu, Button,
        Checkbox,
        CheckboxGroup,
        Loading
    } from 'element-ui'
    import swal from 'sweetalert2'
    import moment from 'moment'
    import CabeceraInformes from "@/components/CabeceraInformes/CabeceraInformes.vue";
    import bus from '../../../../bus'
    import { mapState } from 'vuex'

    export default {
        created() {
            this.loading = Loading.service({ text: "Cargando..." });
            this.$store.dispatch("setNameRoute", "Ventas materias primas");
            this.getBusiness();

            if (this.$store.getters.dateTo && this.$store.getters.dateFrom) {

                this.datefrom = this.$store.getters.dateFrom;
                this.dateto = this.$store.getters.dateTo;
            }

            bus.$on('get-ventas', (item) => {


                this.getVentas();
            });

            bus.$on('get-business', (idBusiness) => {
                this.idBusiness = idBusiness;
                this.idsTPV = [];
                this.idTpv = 0;

                this.getTpv();


            });
            bus.$on('get-tpv', (idTpv) => {
                this.idTpv = idTpv;


                this.changeTPV();


            });

            bus.$on('get-date', (dates) => {
                this.value4 = dates;


                this.getSalesProducts();

            });

            bus.$on('get-open-modal', (item) => {
                this.openModal();

            });

        },
        components: {
            //CabeceraInformes,
            [DatePicker.name]: DatePicker,
            [Select.name]: Select,
            [Dropdown.name]: Dropdown,
            [DropdownItem.name]: DropdownItem,
            [DropdownMenu.name]: DropdownMenu,
            [Button.name]: Button,
            [Option.name]: Option,
            [Checkbox.name]: Checkbox,
            [CheckboxGroup.name]: CheckboxGroup,
            CabeceraInformes
        },
        data() {
            return {
                loading: null,
                datefrom: new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString(),
                dateto: new Date().toISOString(),
                listBusinesses: [],
                idBusiness: 0,
                value4: [new Date(new Date().getFullYear(), new Date().getMonth(), 1), new Date()],
                list: [''],
                mode: 0,
                $Chart: null,
                objectChart: null,
                contador: 0,
                chartIn: 0,
                listTpv: [],
                idTpv: 0,
                dateRangeOptions1: {
                    firstDayOfWeek: 1

                },
                listCheckBoxTpv: [],
                idsTPV: [],
                nombreFiltro: "none",

                ordenacionProductos: 0,
                ordenacionBarcode: 0,
                ordenacionProveedor: 0,
                ordenacionTag: 0,
                ordenarCantidad: 0,
                ordenarCosto: 0,
                ordenarImporte: 0,
                ordenarPrecioMed: 0,
                ordenarTipo: 0,

                respuesta: true,

                //FILTRO
                filterTag: [],
                idFiltro: 0,
            }
        },
        computed: {
            ...mapState(["permiso"]),
            urlExportPDF() {


                var tpv = "";

                this.idsTPV.forEach(function (d) {
                    tpv += d + ',';

                });

                return this.$store.getters.apiUrl+"/subproducts/exportVentasMateriaPrima/PDF?idBusiness=" + this.idBusiness + "&idFilter=" + this.idFiltro + "&nombreFiltro=" + this.nombreFiltro + "&idTpv=" + tpv + "&datefrom=" + moment(this.datefrom).startOf("day").unix() + "&dateto=" + moment(this.dateto).endOf("day").unix() + "&jwt=" + this.$store.getters.jwt

            },
            urlExportExcel() {

                var tpv = "";

                this.idsTPV.forEach(function (d) {
                    tpv += d + ',';

                });
                return this.$store.getters.apiUrl+"/subproducts/exportVentasMateriaPrima/Excel?idBusiness=" + this.idBusiness + "&idFilter=" + this.idFiltro + "&nombreFiltro="+this.nombreFiltro+"&idTpv=" + this.idsTPV + "&datefrom=" + moment(this.datefrom).startOf("day").unix() + "&dateto=" + moment(this.dateto).endOf("day").unix() + "&jwt=" + this.$store.getters.jwt

            },


            getTotalPrecio() {
                let total = 0;
                this.list.forEach(function (d) {

                    if( d.escandallo > 1){
                        total += (d.precioCompra/d.escandallo) *d.units;
                    }else{
                        total += d.precioCompra * d.units;
                    }

                });
                return total;
            }
        },
        methods: {
            cambioBusiness(idBusinessData, listTpv) {
                if (listTpv) {
                    this.listTpv = listTpv;
                }
                
                this.loading = Loading.service({ text: "Cargando..." });
                this.idBusiness = idBusinessData;
                this.idTpv = -1;
                this.idsTPV = [];
                this.list = [];
                this.idFiltro = 0;
                this.getCategory();
                this.cambioTpv(this.idTpv);
            },

            emitirConsulta() {
                this.loading = Loading.service({ text: "Cargando..." });
                this.getSalesProducts();
            },

            cambioTpv(idTpvData, filtrar) {

                if (idTpvData != undefined) {
                    this.idTpv = idTpvData;

                    this.changeTPV();
                }
                
                this.idTpv=idTpvData;
                this.emitirConsulta();
            },

            cambioHora(dates) {
                this.datefrom = dates[0]
                this.dateto = dates[1]
            },
            sortedArrayCostoASC: function () {
                this.ordenarCosto = 1;

                function compare(a, b) {
                    if ((a.precioCompra / a.escandallo) * a.units < (b.precioCompra / b.escandallo) * b.units)
                        return -1;
                    if ((a.precioCompra / a.escandallo) * a.units > (b.precioCompra / b.escandallo) * b.units)
                        return 1;
                    return 0;
                }

                return this.list.sort(compare);
            },
            selectNombreFiltro: function () {
                this.filterTag.forEach(t => {
                    if (t.id == this.idFiltro) {
                        this.nombreFiltro = t.name;
                    }
                });

                if (this.idFiltro == 0) {
                    this.nombreFiltro = "none";
                }
            },
            sortedArrayCostoDESC: function () {
                this.ordenarCosto = 0;

                function compare(a, b) {

                    if ((a.precioCompra / a.escandallo) * a.units > (b.precioCompra / b.escandallo) * b.units)
                        return -1;
                    if ((a.precioCompra / a.escandallo) * a.units < (b.precioCompra / b.escandallo) * b.units)
                        return 1;
                    return 0;
                }

                return this.list.sort(compare);
            },


            sortedArrayNameASC: function () {
                this.ordenacionProductos = 1;

                function compare(a, b) {
                    if (a.name.toUpperCase() < b.name.toUpperCase())
                        return -1;
                    if (a.name.toUpperCase() > b.name.toUpperCase())
                        return 1;
                    return 0;
                }

                return this.list.sort(compare);
            },
            sortedArrayNameDESC: function () {
                this.ordenacionProductos = 0;

                function compare(a, b) {

                    if (a.name.toUpperCase() > b.name.toUpperCase())
                        return -1;
                    if (a.name.toUpperCase() < b.name.toUpperCase())
                        return 1;
                    return 0;
                }

                return this.list.sort(compare);
            },
            sortedArrayNameProveedorASC: function () {
                this.ordenacionProveedor = 1;

                function compare(a, b) {
                    if (a.nameProveedor.toUpperCase() < b.nameProveedor.toUpperCase())
                        return -1;
                    if (a.nameProveedor.toUpperCase() > b.nameProveedor.toUpperCase())
                        return 1;
                    return 0;
                }

                return this.list.sort(compare);
            },
            sortedArrayNameProveedorDESC: function () {
                this.ordenacionProveedor = 0;

                function compare(a, b) {

                    if (a.nameProveedor.toUpperCase() > b.nameProveedor.toUpperCase())
                        return -1;
                    if (a.nameProveedor.toUpperCase() < b.nameProveedor.toUpperCase())
                        return 1;
                    return 0;
                }

                return this.list.sort(compare);
            },
            sortedArrayNameTagASC: function () {
                this.ordenacionTag = 1;

                function compare(a, b) {
                    if (a.nameTag.toUpperCase() < b.nameTag.toUpperCase())
                        return -1;
                    if (a.nameTag.toUpperCase() > b.nameTag.toUpperCase())
                        return 1;
                    return 0;
                }

                return this.list.sort(compare);
            },
            sortedArrayNameTagDESC: function () {
                this.ordenacionTag = 0;

                function compare(a, b) {

                    if (a.nameTag.toUpperCase() > b.nameTag.toUpperCase())
                        return -1;
                    if (a.nameTag.toUpperCase() < b.nameTag.toUpperCase())
                        return 1;
                    return 0;
                }

                return this.list.sort(compare);
            },
            sortedArrayCantidadASC: function () {
                this.ordenarCantidad = 1;

                function compare(a, b) {
                    if (a.units < b.units)
                        return -1;
                    if (a.units > b.units)
                        return 1;
                    return 0;
                }

                return this.list.sort(compare);
            },
            sortedArrayCantidadDESC: function () {
                this.ordenarCantidad = 0;

                function compare(a, b) {

                    if (a.units > b.units)
                        return -1;
                    if (a.units < b.units)
                        return 1;
                    return 0;
                }

                return this.list.sort(compare);
            },
            sortedArrayImporteASC: function () {
                this.ordenarImporte = 1;

                function compare(a, b) {
                    if (a.importe < b.importe)
                        return -1;
                    if (a.importe > b.importe)
                        return 1;
                    return 0;
                }

                return this.list.sort(compare);
            },
            sortedArrayImporteDESC: function () {
                this.ordenarImporte = 0;

                function compare(a, b) {

                    if (a.importe > b.importe)
                        return -1;
                    if (a.importe < b.importe)
                        return 1;
                    return 0;
                }

                return this.list.sort(compare);
            },
            sortedArrayPrecioMedASC: function () {
                this.ordenarPrecioMed = 1;

                function compare(a, b) {
                    if (a.importe / a.cantidad < b.importe / b.cantidad)
                        return -1;
                    if (a.importe / a.cantidad > b.importe / b.cantidad)
                        return 1;
                    return 0;
                }

                return this.list.sort(compare);
            },
            sortedArrayPrecioMedDESC: function () {
                this.ordenarPrecioMed = 0;

                function compare(a, b) {

                    if (a.importe / a.cantidad > b.importe / b.cantidad)
                        return -1;
                    if (a.importe / a.cantidad < b.importe / b.cantidad)
                        return 1;
                    return 0;
                }

                return this.list.sort(compare);
            },
            sortedArrayTipoASC: function () {
                this.ordenarTipo = 1;

                function compare(a, b) {
                    if (a.type < b.type)
                        return -1;
                    if (a.type > b.type)
                        return 1;
                    return 0;
                }

                return this.list.sort(compare);
            },
            sortedArrayTipoDESC: function () {
                this.ordenarTipo = 0;

                function compare(a, b) {

                    if (a.type > b.type)
                        return -1;
                    if (a.type < b.type)
                        return 1;
                    return 0;
                }

                return this.list.sort(compare);
            },
            sortedArrayBarcodeASC: function () {
                this.ordenacionBarcode = 1;

                function compare(a, b) {
                    if (a.cod_ean.toUpperCase() < b.cod_ean.toUpperCase())
                        return -1;
                    if (a.cod_ean.toUpperCase() > b.cod_ean.toUpperCase())
                        return 1;
                    return 0;
                }

                return this.list.sort(compare);
            },
            sortedArrayBarcodeDESC: function () {
                this.ordenacionBarcode = 0;

                function compare(a, b) {
                    if (a.cod_ean.toUpperCase() > b.cod_ean.toUpperCase())
                        return -1;
                    if (a.cod_ean.toUpperCase() < b.cod_ean.toUpperCase())
                        return 1;
                    return 0;
                }

                return this.list.sort(compare);
            },

            changeTPV() {
                if (this.idTpv === -1) {


                    this.idsTPV = [];

                    for (let i = 0; i < this.listTpv.length; i++) {

                        this.idsTPV.push(this.listTpv[i].id)
                    }
                }
                else {

                    this.idsTPV = []
                    this.idsTPV.push(this.idTpv)

                }
                this.getSalesProducts();
            },

            openModal() {

                this.$modal.show('filtradoTPV');

            },

            getTpv() {

                this.listTpv = [];

                var config = {
                    params: {
                        idBusiness: this.idBusiness,
                        jwt: this.$store.getters.jwt
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                let vm = this;
                this.axios.get(this.$store.getters.apiUrl + "general/getTpvsByBusiness", config)
                    .then(function (response) {
                        if (response.data.response) {


                            for (let i = 0; i < response.data.result.length; i++) {
                                vm.idsTPV.push(response.data.result[i].id)
                            }

                            vm.listCheckBoxTpv = response.data.result;

                            for (let i = 0; i < response.data.result.length; i++) {

                                let printername = {
                                    nameShow: response.data.result[i].nameShow,
                                    id: response.data.result[i].id
                                };

                                vm.listTpv.push(printername)
                            }

                            vm.getCategory();
                            vm.getSalesProducts();

                        }

                    })
                    .catch(function (error) {
                        console.log(error);
                    });

            },

            getBusiness() {
                var config = {
                    params: {
                        jwt: this.$store.getters.jwt
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                let vm = this;

                this.axios.get(this.$store.getters.apiUrl + "general/getBusinessesByUser", config)
                    .then(function (response) {
                        vm.listBusinesses = response.data.result;

                        if (vm.$store.getters.idBusiness) {
                            vm.idBusiness = vm.$store.getters.idBusiness;
                        }
                        else {

                            vm.idBusiness = response.data.result[0].id;
                        }


                        vm.getTpv();

                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
            getSalesProducts() {

                this.selectNombreFiltro();
                this.$modal.hide('filtradoTPV');


                if (this.datefrom === null || this.dateto === null) {
                    swal({
                        title: this.$t('ups'),
                        text: this.$t('seleccioneUnaFechaDeInicioYUnaFechaDeFin'),
                        confirmButtonClass: 'btn btn-info btn-fill',
                        type: 'error'
                    });
                    vm.loading.close();
                } else {

                    let secondsDesde = moment(this.datefrom).unix();
                    let secondsHasta = moment(this.dateto).unix();

                    if (secondsHasta < secondsDesde) {
                        swal({
                            title: this.$t('ups'),
                            text: this.$t('laFechaDeInicioNoPuedeSerPosteriorALaDeFin'),
                            confirmButtonClass: 'btn btn-info btn-fill',
                            type: 'error'
                        });

                        vm.loading.close();
                    } else {

                        this.$store.dispatch("setDateTo", this.dateto);
                        this.$store.dispatch("setDateFrom", this.datefrom);

                        var config = {
                            params: {
                                idFilter: this.idFiltro,
                                idBusiness: this.idBusiness,
                                datefrom: moment(this.datefrom).startOf("day").unix(),
                                dateto: moment(this.dateto).endOf("day").unix(),
                                idTpv: this.idsTPV,
                                jwt: this.$store.getters.jwt
                            },
                            headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                        };

                        let vm = this;
                        this.$store.dispatch("setIdBusiness", this.idBusiness);
                        this.axios.get(this.$store.getters.apiUrl + "subproducts/getSalesSubproducts", config)
                            .then(function (response) {
                                if (response.data.response) {

                                    vm.list = response.data.result;
                                    vm.initChart();

                                    vm.respuesta = true;

                                }else if (response.data.response == false && response.data.rangoMayor == true) {
                                    swal({
                                    title: "Lo sentimos",
                                    text: response.data.result,
                                    confirmButtonClass: "btn btn-info btn-fill",
                                    type: "info",
                                    });
                                    vm.respuesta = false;
                                }
                                else {
                                    swal({
                                        title: vm.$t('accesoDenegado'),
                                        text: response.data.message,
                                        confirmButtonClass: 'btn btn-info btn-fill',
                                        type: 'error'
                                    });
                                    vm.respuesta = false;

                                }
                                vm.loading.close();

                            })
                            .catch(function (error) {
                                console.log(error);
                            });
                    }
                }
            },


            calcularUnidades(unidades, escandallo) {

                if (escandallo === 1) {
                    return unidades;
                }
                else if (escandallo === 0) {

                    return 0;

                } else {
                    return (unidades - (unidades % escandallo)) / escandallo;
                }

            },


            calcularPartes(unidades, escandallo) {


                if (escandallo === 1) {
                    return 0
                }
                else if (escandallo === 0) {

                    return 0;

                } else {
                    return unidades % escandallo;
º                }


            },
            calcularEscandallo(escandallo) {


                if (escandallo === 1) {
                    return 0
                }
                else if (escandallo === 0) {

                    return 0;

                } else {
                    return  escandallo;
                }

            },
            
            getCategory() {
                var config = {
                    params: {
                        idBusiness: this.idBusiness,
                        jwt: this.$store.getters.jwt
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };
                this.$store.dispatch("setIdBusiness", this.idBusiness);
                let vm = this;
                this.axios.get(this.$store.getters.apiUrl + 'subproducts/getTagsByBusiness', config)
                    .then(function (response) {
                        if (response.data.response) {

                            vm.filterTag = [];

                            if (response.data.result.length === 0) {

                                let category = {
                                    name: "Todas las etiquetas",
                                    id: 0,
                                    code: 0,
                                    parentCode: 0
                                };

                                vm.filterTag.push(category);

                            }

                            for (let i = 0; i < response.data.result.length; i++) {

                                if (i === 0) {

                                    let category = {
                                        name: "Todas las etiquetas",
                                        id: 0,
                                        code: 0,
                                        parentCode: 0
                                    };

                                    vm.filterTag.push(category);

                                }


                                let categoryname = {
                                    name: response.data.result[i].name,
                                    id: response.data.result[i].id,
                                    code: response.data.result[i].code,
                                    parentCode: response.data.result[i].parentCode
                                };

                                vm.filterTag.push(categoryname)

                            }

                        } else {
                            vm.loading.close();
                            swal({
                                title: vm.$t('atencion'),
                                text: response.data.message,
                                confirmButtonClass: 'btn btn-info btn-fill',
                                type: 'error'
                            });
                        }

                    });
            },

            initChart() {


                var labels = this.list.map(function (x) {
                    return x.name;
                });

                var data = this.list.map(function (x) {
                    return x.units;
                });


                var randomColor = require('randomcolor');

                var colors = randomColor({luminosity: 'dark', count: labels.length, format: 'rgb'});

                let backgroundColors = colors.map(function (x) {
                    let xcolors = x.substring(x.indexOf("(") + 1, x.length - 1).split(",");
                    return "rgba(" + xcolors[0] + "," + xcolors[1] + "," + xcolors[2] + ", 0.6)";
                });

                let borderColors = colors.map(function (x) {
                    let xcolors = x.substring(x.indexOf("(") + 1, x.length - 1).split(",");
                    return "rgba(" + xcolors[0] + "," + xcolors[1] + "," + xcolors[2] + ", 0.3)";
                });

                let hoverBackgroundColors = colors.map(function (x) {
                    let xcolors = x.substring(x.indexOf("(") + 1, x.length - 1).split(",");
                    return "rgba(" + xcolors[0] + "," + xcolors[1] + "," + xcolors[2] + ", 1)";
                });

                if (this.contador == 0) {

                    if (this.list.length > 0) {
                        this.objectChart = new Chart("chart", {

                            type: 'pie',
                            data: {
                                labels: labels,
                                datasets: [{
                                    data: data,
                                    backgroundColor: backgroundColors,
                                    borderColor: borderColors,
                                    hoverBackgroundColor: hoverBackgroundColors,
                                    borderWidth: 1
                                }]
                            },
                            options: {
                                legend: {
                                    display: false,
                                    position: 'bottom',
                                },
                                maintainAspectRatio: false,

                            }
                        });


                        this.contador++;
                    }
                }
                else {

                    this.objectChart.destroy();

                    this.objectChart = new Chart('chart', {

                        type: 'pie',
                        data: {
                            labels: labels,
                            datasets: [{
                                data: data,
                                backgroundColor: backgroundColors,
                                borderColor: borderColors,
                                hoverBackgroundColor: hoverBackgroundColors,
                                borderWidth: 1
                            }]
                        },
                        options: {
                            legend: {
                                display: false,
                                position: 'bottom',
                            },
                            maintainAspectRatio: false,


                        }
                    });

                }
            }
        }
    }
</script>

<style scoped>


    a li {
        color: #111;
    }

    .card {
        padding: 20px;
    }

    .div-export {
        margin-bottom: 10px;
    }

    body {
        background: #1D1F20;
        padding: 16px;
    }

    .chart-container {
        position: relative;
        margin: auto;
        height: 80vh;
        width: 80vw;
    }


</style>


// WEBPACK FOOTER //
// src/pages/Dashboard/Informes/Subproductos/VentasSubproductos.vue